// FileTreeView — lista (achatada) dos arquivos que o Mac anuncia para um
// dispatch. nodes = [{ name, path }]. (A COLETA da árvore no runner via IPC é
// deferida — ver DECISIONS D-V2-007; sem nodes, não renderiza nada.)

export default function FileTreeView({ nodes = [] }) {
  if (!nodes.length) return null;
  return (
    <ul className="flex flex-col gap-0.5 text-xs text-apolo-textTertiary" aria-label="Arquivos">
      {nodes.map((n) => (
        <li key={n.path || n.name} className="truncate">
          {n.name || n.path}
        </li>
      ))}
    </ul>
  );
}
